var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"images-loaded",rawName:"v-images-loaded",value:(_vm.loaded),expression:"loaded"}],attrs:{"id":"app"}},[_c('SunHeroHeader'),_c('main',[_c('router-view')],1),_c('SunHeroFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }